<!-- Formulario de inicio de sesion  centrado a lo largo y ancho de la pantalla -->
<div class="row">
  <div class="login-page">
    <div class="form">
      <h4 class="text-center pt-0 mt-0 pb-2"><i class="fa fa-lock"></i> Member Login</h4>
      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="login()">
        <h5 *ngIf="confirmBtn" class="text-center">Reset Password</h5>

        <input [(ngModel)]="email" type="email" autocomplete="off" formControlName="email" name="email"
          placeholder="username" />
        <input *ngIf="!confirmBtn && !checkEmailBtn" type="password" autocomplete="off" formControlName="password"
          name="password" placeholder="password" />

        <!-- Unified Error Section -->
        <div *ngIf="(submitted && formErrors.length) || firebaseErrorMessage"
          class="alert alert-danger mt-2 error-section">
          <ul class="mb-0">
            <li *ngFor="let error of formErrors">{{ error }}</li>
            <li *ngIf="firebaseErrorMessage">{{ firebaseErrorMessage }}</li>
          </ul>
        </div>


        <!-- Additional Action Prompt -->
        <p *ngIf="firebaseErrorMessage && !confirmBtn && !checkEmailBtn &&
          firebaseErrorMessage !== 'There is no user record corresponding to this identifier. The user may have been deleted.' &&
          firebaseErrorMessage !== 'The email address is badly formatted.'">
          Forget your password? <span id="linkLike" (click)="resetPassword()">Reset Here</span>
        </p>

        <!-- Spinner -->
        <div class="spinner-border text-primary" role="status" *ngIf="showLoader">
          <span class="sr-only">Loading...</span>
        </div>

        <!-- Password Reset -->
        <p *ngIf="checkEmailBtn" class='alert alert-success'>
          Reset link has been sent to this address. Please check your email to continue.
        </p>

        <button *ngIf="checkEmailBtn" class="btn btn-block btn-info" (click)="return()">Return</button>
        <button *ngIf="confirmBtn" class="btn btn-block btn-secondary" (click)="return()">Cancel</button>
        <button *ngIf="confirmBtn" class="btn btn-block btn-info" (click)="confirmReset()">Confirm Email</button>

        <input *ngIf="!showLoader && !confirmBtn && !checkEmailBtn" type="submit" value="Login" class="button">
      </form>
    </div>
  </div>
</div>